varying vec3 vNormalEye;  
varying vec3 vViewPosition;


void main(){
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    vNormalEye = normalize(normalMatrix * normal);
    vViewPosition = -mvPosition.xyz;
    gl_Position = projectionMatrix * mvPosition;
}